export const compare = (lhs, rhs) => {
    if (typeof lhs === 'number' && typeof rhs === 'number') {
        return lhs - rhs;
    }
    return new Intl.Collator().compare(lhs, rhs);
};
